import { ToastViewport } from '@catering/ui';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import type { JSX } from 'react';

import { useRestoreSession } from './auth/use-restore-session';
import { OfflineSyncRunner } from './deliveries/offline-sync-runner';
import { PwaUpdatePrompt } from './pwa/pwa-update-prompt';
import { router } from './routes/router';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // The client refreshes the access token on a 401 by itself, so a retry
      // here would only multiply requests that were going to fail anyway.
      retry: false,
      staleTime: 30_000,
    },
  },
});

export function App(): JSX.Element {
  return (
    <QueryClientProvider client={queryClient}>
      <SessionGate />
    </QueryClientProvider>
  );
}

/**
 * Restores the session before the router decides anything.
 *
 * It has to be inside the query provider and outside the router: the restore
 * uses the API client, and the router's guard reads the result.
 */
function SessionGate(): JSX.Element {
  useRestoreSession();

  return (
    <>
      <RouterProvider router={router} />
      <ToastViewport />
      <PwaUpdatePrompt />
      <OfflineSyncRunner />
    </>
  );
}
